__turbopack_context__.v({
  "content_box": "iYuKEG_content_box",
  "grid_block": "iYuKEG_grid_block",
  "homepageWrapper": "iYuKEG_homepageWrapper",
  "logo_wrapper": "iYuKEG_logo_wrapper",
  "main_wrapper": "iYuKEG_main_wrapper",
  "medical_decline": "iYuKEG_medical_decline",
  "medical_page": "iYuKEG_medical_page",
  "medical_questions": "iYuKEG_medical_questions",
  "question_layout": "iYuKEG_question_layout",
  "question_layout_wrapper": "iYuKEG_question_layout_wrapper",
});
